import { useEffect, useState } from "react";
import { Trophy, Store, PartyPopper } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Carousel de últimos 5 ganadores del juego "Atínale al Precio".
 * Se muestra en el hero B2C para motivar a jugar.
 */
export default function WinnersCarousel() {
  const [winners, setWinners] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/api/public/atinale/winners?limit=5`)
      .then(({ data }) => setWinners(data.winners || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (winners.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % winners.length), 4000);
    return () => clearInterval(t);
  }, [winners.length]);

  if (winners.length === 0) return null;

  return (
    <div className="mt-4 rounded-2xl bg-gradient-to-r from-amber-400 via-[#FF007A] to-[#0055FF] p-[2px] shadow-lg" data-testid="winners-carousel">
      <div className="bg-white rounded-2xl px-3 py-2.5 sm:py-3">
        <div className="flex items-center gap-1.5 mb-1.5">
          <Trophy className="w-3.5 h-3.5 text-amber-500" />
          <span className="text-[10px] font-extrabold uppercase tracking-widest text-amber-600">Últimos ganadores</span>
          <span className="ml-auto text-[10px] text-neutral-400 tabular-nums">{idx + 1}/{winners.length}</span>
        </div>
        <div className="relative overflow-hidden">
          {winners.map((w, i) => (
            <div
              key={`${w.challenge_id}-${w.created_at}`}
              className={`transition-opacity duration-500 ${i === idx ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`}
              data-testid={`winner-slide-${i}`}
            >
              <div className="flex items-center gap-3">
                {w.image ? (
                  <img src={w.image} alt="" className="w-14 h-14 rounded-xl object-cover shrink-0 ring-2 ring-amber-400" />
                ) : (
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-400 to-[#FF007A] grid place-items-center shrink-0">
                    <PartyPopper className="w-6 h-6 text-white" />
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-heading font-extrabold text-neutral-900 truncate">
                    🎉 {w.user_name} ganó
                  </div>
                  <div className="text-xs text-neutral-600 truncate">
                    <strong>{w.product_name}</strong>
                    <span className="text-neutral-400 mx-1">·</span>
                    <Store className="w-3 h-3 inline text-[#FF007A]" /> {w.business_name}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
